import React from 'react';
import Lng from './Lng';
import 'moment/locale/en-gb';
import 'moment/locale/de';

function LanguageSwitcher() {
    return (
        <>
            <Lng lng="en" /> &#x2b04; <Lng lng="de" />
        </>
    );
}

export default LanguageSwitcher;
